<template>
    <v-card height="100%">
        <Toolbar
            :showDrawer="!(showAdd || showDelete)"
            @backEmit="reset"
            :toolbarTitle="toolbarText"
            :tooltipMessage="$t('Auf dieser Seite haben Sie Überblick auf Ihre Foren')"
        />
        <v-container fluid>
            <v-row no-gutters>
                <v-col :cols="12">
                    <keep-alive>
                        <component
                            :is="isComponent"
                            :type="type"
                            @create="handleCreate"
                            @update="handleUpdate"
                            @delete="handleDelete"
                            :permissions="editorPermissions"
                            @input="reset"
                        />
                    </keep-alive>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>
import ForumMixin from '../../Components/Forum/Mixins/ForumMixin';

import Toolbar from '../../Components/Generic/Toolbar';
import ForumList from '../../Components/Forum/ForumList';
import AddUpdateForum from '../../Components/Forum/AddUpdateForum';
import DeleteForum from '../../Components/Forum/DeleteForum';

export default {
    name: 'forum',
    components: {
        Toolbar,
        ForumList,
        AddUpdateForum,
        DeleteForum
    },
    mixins: [ForumMixin],
    data: () => ({
        showAdd: false,
        showDelete: false,
        type: 'ADD',
        editorPermissions: {
            add: false,
            update: false,
            delete: false,
            move: false,
            copy: false,
            details: false,
            groups: false
        }
    }),
    computed: {
        isSelected() {
            return Object.keys(this.getSelectedForum).length > 0;
        },
        isComponent() {
            if (this.showAdd) {
                return AddUpdateForum;
            }
            if (this.showDelete) {
                return DeleteForum;
            }
            return ForumList;
        },
        toolbarText() {
            if (this.showAdd) {
                switch (this.type) {
                    case 'ADD':
                        return this.$t('Forum erstellen');
                    case 'UPDATE':
                        return this.$t('Forum bearbeiten');
                }
            }
            return this.$t('Foren');
        }
    },
    methods: {
        reset() {
            this.showAdd = false;
            this.showDelete = false;
        },
        handleDelete() {
            this.showDelete = true;
        },
        handleCreate() {
            this.type = 'ADD';
            this.showAdd = true;
        },
        handleUpdate() {
            this.type = 'UPDATE';
            this.showAdd = true;
        }
    },
    mounted() {
        const permissions = {
            add: ['FORUM_MANAGEMENT'],
            update: ['FORUM_MANAGEMENT'],
            delete: ['FORUM_MANAGEMENT'],
            move: false,
            copy: false,
            details: false,
            groups: false
        };
        this.validateEditorState(permissions).then((result) => {
            this.editorPermissions = result;
        });
    }
};
</script>
